<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection title="Assignment KPI Pegawai">
          <div class="text-right">
            <ArgonButton :to="{ name: 'Create Assignment KPI Pegawai' }" isRouteLink>+ Tambah Assignment KPI</ArgonButton>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <!-- <CardComponent :useHeader="true"> -->
        <CardComponent use-header>
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <!-- <FormGroup class="m-0 w-50">
                    <select @change="getData()" class="form-control" v-model="params.limit">
                      <option v-for="(item, index) in limit_list" :key="index" :value="item">{{ item }} data</option>
                    </select>
                  </FormGroup> -->

                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                      placeholder="Cari NIP/nama pegawai..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.periode_id"
                      :list="list_periode"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Periode"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.unitkerja_id"
                      :list="unitkerja.sort((a, b) => a.name.localeCompare(b.name))"
                      option-value="id"
                      option-text="name"
                      placeholder="Pilih Unit Kerja"
                    />
                  </FormGroup>

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.status"
                      :list="status_list.map((item) => {
                          return {
                              value:item,
                              text:status_label?.[item]
                          }
                      })"
                      option-value="value"
                      option-text="text"
                      placeholder="Pilih Status"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>                  
                  <th
                    v-for="item in thead"
                    :key="item"
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  >
                    {{ item }}
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data.length === 0">
                  <td :colspan="thead.length+1" class="text-center p-4">Data tidak ditemukan</td>
                </tr>
                <tr v-for="(item, index) in data" :key="index">
                  <!-- <td>{{ item?.employees?.[0]?.nip || '-' }}</td> -->
                  <td>{{ item?.nip || '-' }}</td>
                  <!-- <td class="font-weight-bolder">{{ item?.employees?.[0]?.name || '-' }}</td> -->
                  <td class="font-weight-bolder">{{ item?.nama || '-' }}</td>
                  <!-- <td>{{ item?.employees?.[0]?.jabatan?.name || '-' }}</td> -->
                  <td><div class="column-truncate">{{ item?.unitkerja || '-' }}</div></td>
                  <td><div class="column-truncate">{{ item?.jabatan || '-' }}</div></td>
                  <!-- <td>{{ item?.employees?.[0]?.position || '-' }}</td> -->
                  <td>{{ item?.position || '-' }}</td>
                  <td>{{ item?.periode || '-' }}</td>
                  <td>
                    <argon-badge :color="status_color?.[item?.status] || 'default'">
                      <span class="text-capitalize">{{ status_label?.[item?.status] || item?.status }}</span>
                    </argon-badge>
                  </td>
                  <!-- <td>
                    <argon-badge :color="item?.status === 'submission' ? 'info' : ((item?.status || '')?.substr(0, 6) === 'accept' ? 'success' : 'danger')">
                      {{ item?.status === 'submission' ? 'Diajukan' : ((item?.status || '')?.substr(0, 6) === 'accept' ? 'Disetujui' : 'ditolak') }}
                    </argon-badge>
                  </td> -->
                  <td>
                    <!-- <button class="btn">
                      <i class="fas fa-ellipsis-h cursor-pointer" aria-hidden="true"></i>
                    </button> -->
                    <ThreeDotsMenu>
                      <router-link
                        :to="{ name: 'Detail Assignment KPI Pegawai', params: { id: item.id, periode_id: item.periode_id, status: item?.status?.replaceAll(' ', '_') } }"
                        class="text-secondary font-weight-bold text-xs btn btn-link"
                      >
                        Detail
                      </router-link>
                      <button @click.prevent="deleteData({ id: item.id, periode_id: item.periode_id, jabatan_id: item.jabatan_id })"
                      class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                      data-original-title="Delete user">Hapus</button>
                    </ThreeDotsMenu>
                  </td>
                </tr>
              </tbody>
              
            </table>
          </div>

          <ArgonPagination
            :page="params.page"
            :total_page="metaData?.total_page"
            :current_page="metaData?.current_page"
            @changepage="changePage"
            @changelimit="changeLimit"
          />

          <!-- <div class="d-flex justify-content-between align-items-center mt-4">
            <span class="text-secondary text-sm">
              {{ params.page != 1 ? (params.page - 1) * params.limit + 1 : (data.length > 0 ? '1' : '0') }} - {{ params.page != 1 ? (params.page - 1) * params.limit + (metaData?.per_page || 0) : (data.length > 0 ? '1' : '0') }} dari {{ metaData?.total_item || 0 }} data
            </span>
            
            <div class="pagination mt-3">
              <vue-awesome-paginate
                :total-items="metaData?.total_item || 0"
                :items-per-page="5"
                :max-pages-shown="5"
                v-model="params.page"
                :on-click="changePage"
                paginate-buttons-class="btn btn-outline-secondary btn-xs btn-pagination"
                active-page-class="btn-active"
                back-button-class="back-btn"
                next-button-class="next-btn"
              />
            </div>
          </div> -->
            <!-- :page-count="list?.total_page || 0" -->
            <!-- :page-link-class="'router-link-active router-link-exact-active pagination__item'"
            :prev-link-class="'router-link-active router-link-exact-active pagination__item'"
            :next-link-class="'router-link-active router-link-exact-active pagination__item'"
            :active-class="'pagination__item--active'" -->
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import FormGroup from '@/components/FormGroup.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
// import Paginate from "vuejs-paginate-next";

import UnitKerjaApi from '@/repository/api/UnitKerjaApi';
// import KpiUsulanApi from '@/repository/api/KpiUsulanApi';
import AssignmentKpiApi from '@/repository/api/AssignmentKpiApi';
import KpiPeriodeApi from '@/repository/api/KpiPeriodeApi';
import ArgonPagination from '@/components/ArgonPagination.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  name: "tables",
  components: {
    ArgonButton,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ThreeDotsMenu,
    FormGroup,
    MetaSection,
    GridRow,
    GridCol,
    // Paginate,
    ArgonPagination,
    ModelListSelect,
  },
  data() {
    return {
      data: [],
      metaData: {},
      unitkerja: [],
      limit_list: [2, 10, 25, 50, 100],
      list_periode: [],
      params: {
        status: "",
        unitkerja_id: "",
        keyword: "",
        limit: 10,
        page: 1,
        periode_id: '',
        list_mode: '',
      },
      timer: null,
      thead: [
        'NIP',
        'Nama',
        'Unit Kerja',
        'Jabatan',
        'Posisi',
        'Periode',
        'Status',
        '', // actions
      ],
      status_list: [
        "assigned to employee",
        "submission",
        "accept by admin",
        "reject by admin",
      ],
      status_color: {
        "assigned to employee": 'warning',
        "submission": 'info',
        "accept by admin": 'success',
        "reject by admin": 'danger',
      },
      status_label: {
        submission: 'Diajukan',
        resubmission: 'Diajukan Ulang',
        reject_direct_supervisor: 'Ditolak Direct SPV',
        accept_direct_supervisor: 'Diterima Direct SPV',
        revisi_direct_supervisor: 'Revisi Direct SPV',
        reject_immediate_supervisor: 'Ditolak Immediate SPV',
        accept_immediate_supervisor: 'Diterima Immediate SPV',
        
        // assignment only
        'assigned to employee': 'Ditugaskan ke Pegawai',
        'reject by admin': 'Ditolak Admin',
        'accept by admin': 'Diterima Admin',
      },
    };
  },
  watch: {
    'params.unitkerja_id': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.status': {
      handler: async function () {
        await this.getData();
      }
    },
    'params.periode_id': {
      handler: async function () {
        await this.getData()
      }
    },
    // 'params.limit': {
    //   handler: async function () {
    //     await this.getData();
    //   },
    //   deep: false,
    // },
    // 'params.page': {
    //   handler: async function () {
    //   // handler: async function (newVal, oldVal) {
    //     // if (newVal < 1) {
    //     //   this.params.page = oldVal
    //     // } else {
    //     //   await this.getData();
    //     // }
          
    //     if (this.params.page >= 1 && this.params.page <= this.metaData.total_page) await this.getData();
    //   },
    //   deep: false,
    // },
  },
  methods: {
    changeLimit(limit) {
      this.params.limit = limit;
      this.getData();
    },
    async getUnitKerja() {
      this.$store.state.loading = true;
      // await UnitKerjaApi.get()
      await UnitKerjaApi.getbyparam({
        page: 'all',
        status: 'active',
      })
        .then((response) => {
          this.unitkerja = response?.data;
        }).catch(() => {
          this.unitkerja = [];
        });
      this.$store.state.loading = false;
    },
    async getKpiPeriode() {
      await KpiPeriodeApi.getbyparam({
        status: 'active',
        limit: 100,
      })
        .then((response) => {
          this.list_periode = response?.data || [];
          this.params.periode_id = response?.data?.[0]?.id || '';
        })
        .catch((err) => {
          console.log(err)
        });
    },
    async getData(page=1) {
      this.$store.state.loading = true;
      this.data = [];
      this.metaData = {};
      this.params.page = page;

      await AssignmentKpiApi.getList(this.params)
      // await AssignmentKpiApi.getList({
      //   limit: this.params.limit,
      //   page: this.params.page,
      //   periode_id: this.params.periode_id,
      //   list_mode: this.params.list_mode,
      // })
        .then((resp) => {
          // console.log(resp)
          this.data = resp?.data;

          this.metaData = {
            status: resp?.status ?? null,
            message: resp?.message ?? null,
            total_item: resp?.total_item ?? null,
            per_page: resp?.per_page ?? null,
            total_page: resp?.total_page ?? null,
            current_page: resp?.current_page ?? null,
          };
        })
        .catch((err) => {
          console.log(err)
        })
      this.$store.state.loading = false;
    },
    changePage(pageNum) {
      this.getData(pageNum);
    },
    async searchKeyword() {
      clearTimeout(this.timer);
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650)
    },
    async deleteData(payload) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await AssignmentKpiApi.delete(payload)
            .then(() => {
              this.getData();
              this.$swal({
                icon: "success",
                title: "Berhasil"
              });
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.message || 'Something wrong, please try again.',
              });
            });
          this.$store.state.loading = false;
        }
      })
    },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getUnitKerja();
    await this.getKpiPeriode();
    await this.getData();
    this.$store.state.loading = false;
  },
};
</script>
